export default function IconRightArrow({ className }) {
    return (
        <svg
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M13.6309 4.22437C13.2382 3.90402 12.6592 3.92662 12.293 4.29273C11.9269 4.65885 11.9043 5.23785 12.2247 5.63063L12.293 5.7068L17.586 10.9998H4.00008C3.44779 10.9998 3.00008 11.4475 3.00008 11.9998C3.00008 12.5521 3.44779 12.9998 4.00008 12.9998H17.586L12.293 18.2927C11.9025 18.6833 11.9025 19.3163 12.293 19.7068C12.6836 20.0973 13.3166 20.0973 13.7071 19.7068L20.7071 12.7068C21.0976 12.3163 21.0976 11.6833 20.7071 11.2927L13.7071 4.29273L13.6309 4.22437Z"
                fill="currentColor"
            />
        </svg>
    );
}
